import { postData, getData, patchData, deleteData } from 'src/utils/axios';
import { urlMap } from 'src/utils/urls';

export const getProducts = async (clinicId) =>
  getData(`${urlMap.products.all}?clinic_id=${encodeURIComponent(String(clinicId))}`);

export const addProduct = async (productData) =>
  postData(urlMap.products.create, productData);

export const deleteProduct = async (productId, clinicId) =>
  deleteData(
    `${urlMap.products.delete.replace(':productId', productId)}?clinic_id=${encodeURIComponent(String(clinicId))}`
  );

export const getProduct = async (productId, clinicId) =>
  getData(
    `${urlMap.products.byId.replace(':productId', productId)}?clinic_id=${encodeURIComponent(String(clinicId))}`
  );

export const updateProduct = async (productId, productData, clinicId) =>
  patchData(
    `${urlMap.products.update.replace(':productId', productId)}?clinic_id=${encodeURIComponent(String(clinicId))}`,
    productData
  );

export const toggleProduct = async (productId, data, clinicId) =>
  patchData(
    `${urlMap.products.update.replace(':productId', productId)}?clinic_id=${encodeURIComponent(String(clinicId))}`,
    data
  );
export const searchProducts = async (name) =>
  getData(`${urlMap.products.search}?name=${encodeURIComponent(name)}`);
